export const CONSOLIDATE_PRODUCTION = (id, year, month) =>
  `/consolidated_production/${id}/${year}/${month}/`;

export const GET_CONSOLIDATE_PRODUCTION = (year, month, team) =>
  `/consolidated_production/${year}/${month}/?team_id=${team}`;
